import { Injectable } from '@angular/core';
import { GridInput } from '@it2go/data-grid';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { filterFrag } from '../modules/content/service/types/filter.types';
import { OkObject } from '@it2go/types';
import { GuidePageViewRegisterInput } from '@libs/types/src/services/input-type/guide-page-view-register.input';
import { GuidePageViewGridObject } from '@libs/types/src/services/object-type/guide-page-view.object';

@Injectable({ providedIn: 'root' })
export class GuidePageViewGqlService extends GqlServiceV2 {

    public registerGuidePageView(input: GuidePageViewRegisterInput, fragment: string = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: GuidePageViewRegisterInput!) {
                    guidePageView {
                        register(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public getGuidePageViews(
        input: GridInput | null,
        fragment: string = `
            id
            guidePageId
            userId
            createdAt
            user {
                id
                name
                surname
                titleBeforeName
                titleAfterName
            }
        `,
    ) {
        return this.query<GuidePageViewGridObject>(
            `
                query($input: GridInput!) {
                    guidePageView {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${fragment}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

}
